<script setup lang="ts">
import type {
  NotificationsListProps,
  NotificationsListEmits,
} from '@/features/Notifications/model/types/notifications';

import NotificationItem from '@/features/Notifications/ui/NotificationsItem.vue';
import Loader from '@/features/Loader/ui/index.vue';

defineProps<NotificationsListProps>();
const emit = defineEmits<NotificationsListEmits>();
</script>

<template>
  <div class="notifications-list">
    <Loader v-if="isLoading" class="notifications-list__loader" />
    <template v-else-if="notifications.length">
      <NotificationItem
        v-for="item in notifications"
        :key="item.id"
        :title="item.title"
        :subtitle="item.subtitle"
        :time="item.time"
        :icon-name="item.iconName"
        :profile-photo-url="item.profilePhotoUrl"
        :link="item.link"
        @click="emit('read', item.id, item.roomId)"
      />
    </template>
    <div v-else class="notifications-list__empty" data-testid="notifications-empty">
      У вас нет непрочитанных уведомлений
    </div>
  </div>
</template>

<style lang="less">
.notifications-list {
  margin-top: @size-x5;
  display: flex;
  flex-direction: column;
  gap: @size-x4;
  max-height: 420px;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: @color-alto;
    border-radius: @main-size;
  }

  &__loader {
    margin: @size-x10 auto;
  }

  &__empty {
    text-align: center;
    color: @color-silver-chalice;
    font-size: @size-x4;
    font-weight: 500;
    padding: @size-x10 0;
  }
}
</style>
